import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { Button } from '@upme/ui/components/button';
import { Label } from '@upme/ui/components/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@upme/ui/components/select';
import { listCitiesOptions } from '../../../features/cities/queries';
import { useAdminPlaces } from '../../../features/places/api/places.queries';
import { PlacesTable } from '../../../features/places/components/places-table';
import { PageHeader } from '../../../shared/components/page-header';
import { Route as PlacesRoute } from './route';

export const Route = createFileRoute('/_authenticated/places/')({
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(listCitiesOptions());
  },
  component: PlacesIndexPage,
});

const ANY = '__any__';

function PlacesIndexPage() {
  const search = PlacesRoute.useSearch();
  const navigate = useNavigate();
  const { data: cities } = useSuspenseQuery(listCitiesOptions());
  const places = useAdminPlaces(search.cityId ? { cityId: search.cityId } : {});

  return (
    <div>
      <PageHeader
        title="Места"
        description="Список заведений и точек интереса."
        actions={
          <Button asChild>
            <Link to="/places/new">Новое место</Link>
          </Button>
        }
      />
      <div className="mb-4 max-w-xs">
        <Label className="text-xs">Город</Label>
        <Select
          value={search.cityId ?? ANY}
          onValueChange={(v) =>
            navigate({
              to: '/places',
              search: () => (v === ANY ? {} : { cityId: v }),
            })
          }
        >
          <SelectTrigger>
            <SelectValue placeholder="Все" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value={ANY}>Все</SelectItem>
            {cities.map((c) => (
              <SelectItem key={c.id} value={c.id}>
                {c.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <PlacesTable
        places={places.data?.items ?? []}
        isLoading={places.isLoading}
        filtered={Boolean(search.cityId)}
      />
    </div>
  );
}
